import { render, staticRenderFns } from "./PartnerOffers.vue?vue&type=template&id=5811e75e"
import script from "./PartnerOffers.vue?vue&type=script&lang=js"
export * from "./PartnerOffers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports